export const LESSONS_API_URL = '/lessons';
export const SEARCH_API_URL = '/search';
